import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { Loader } from 'semantic-ui-react';

import { useAppStateFeedSelector } from '../feedSlice';
import { loadEventsPosts } from '../feedActionCreators';
import { FeedCard } from './FeedCard';
import { SliderArrow } from '../../../components/sliderArrow/SliderArrow';
import useWindowDimensions from '../../../store/utilities/useWindowDimensions';
import { useAuthSelector } from '../../auth/authSlice';

import styles from './EventsFeedPreview.module.scss';

export const EventsFeedPreview: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();
    const { isAuthenticated } = useAuthSelector((state) => state);
    const { eventsPosts, eventsLoading } = useAppStateFeedSelector((state) => state);

    useEffect(() => {
        // Load 9 upcoming events on mount
        dispatch(loadEventsPosts(1, 9, { onlyEvents: true }));
    }, [dispatch]);

    const getSlidesToShow = () => {
        if (width) {
            if (width < 750) {
                return 1;
            } else if (width < 1400) {
                return 2;
            } else if (isAuthenticated) {
                return 2;
            } else {
                return 3;
            }
        }
        return 1;
    };

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: getSlidesToShow(),
        slidesToScroll: 1,
        prevArrow: <SliderArrow arrowDirection="left" />,
        nextArrow: <SliderArrow arrowDirection="right" />,
    };

    return (
        <div className={styles.eventsPreviewContainer}>
            {!isAuthenticated && (
                <div className={styles.towerContainer}>
                    <img
                        src="https://elginil.gov/ImageRepository/Document?documentID=80625"
                        alt="City of Elgin logo"
                        className={styles.towerImage}
                    />
                </div>
            )}

            <div
                className={styles.eventsSubContainer}
                style={{
                    backgroundColor: isAuthenticated ? 'transparent' : '#f0f2f9',
                }}
            >
                <div className={styles.header}>
                    <h2>{t('Home.WhatsHappening')}</h2>
                </div>

                {eventsLoading ? (
                    <div className={styles.loaderContainer}>
                        <Loader active inline="centered">
                            Loading events...
                        </Loader>
                    </div>
                ) : !eventsPosts || eventsPosts.length === 0 ? (
                    <div className={styles.emptyState}>
                        <p>No upcoming events</p>
                    </div>
                ) : (
                    <>
                        <div className={styles.sliderContainer}>
                            <Slider {...sliderSettings}>
                                {eventsPosts.map((post) => (
                                    <div key={post.id} className={styles.slideWrapper}>
                                        <FeedCard post={post} />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        <div className={styles.viewAllContainer}>
                            <Link to="/events">View All Events</Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
